import { NavLink } from "react-router-dom";
import { LayoutDashboard, SlidersHorizontal, FlaskConical, ShieldCheck, ScrollText, TrendingUp } from "lucide-react";

const items = [
  { to: "/", label: "Home", icon: LayoutDashboard, testid: "nav-home", end: true },
  { to: "/swing", label: "Swing", icon: TrendingUp, testid: "nav-swing" },
  { to: "/config", label: "Config", icon: SlidersHorizontal, testid: "nav-config" },
  { to: "/backtest", label: "Backtest", icon: FlaskConical, testid: "nav-backtest" },
  { to: "/report", label: "Report", icon: ShieldCheck, testid: "nav-report" },
  { to: "/journal", label: "Journal", icon: ScrollText, testid: "nav-journal" },
];

export function BottomNav() {
  return (
    <nav className="glass fixed bottom-0 left-0 right-0 z-40 border-t border-edge" data-testid="bottom-nav">
      <div className="max-w-md mx-auto grid grid-cols-6">
        {items.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-2.5 transition-colors duration-150 ${
                isActive ? "text-pos" : "text-muted2"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={19} strokeWidth={isActive ? 2.5 : 2} />
                <span className="text-[9px] font-semibold uppercase tracking-wider">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
